export default "__VITE_ASSET__1de80df8__"